export default "__VITE_ASSET__BHdiWZXj__"